import React, { Component } from "react";

import { withStyles, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

const styles = theme => ({

})

export default withStyles(styles)(class ValidationSnackbar extends Component {

    render() {
        const {/*classes,*/ open, severity, message} = this.props;
        return (<Snackbar open={open} onClose={this.props.handleClose}>
            <MuiAlert elevation={6} variant="filled" onClose={this.props.handleClose} severity={severity}>
              {message}
            </MuiAlert>
          </Snackbar>)
    }
})